// Номер операции в тексте экранов сопровождения (002: contracts/ui.md, «Доступность»): на экране —
// группами по четыре через дефис, моноширинным kp-code; диктор читает скрытую строку группами
// через пробел — как в OperationCode из @kp/ui, но без кода ошибки и «Скопировать номер».
import { formatOperation, normalizeOperation } from '@kp/contracts';

/** Номер операции: «7F3K-92QD-1A2B», диктор — «7F3K 92QD 1A2B». */
export function OperationText({ operation }: { operation: string }) {
  const shown = formatOperation(normalizeOperation(operation));
  return (
    <span className="kp-code">
      <span aria-hidden="true">{shown}</span>
      <span className="kp-sr-only">{shown.replaceAll('-', ' ')}</span>
    </span>
  );
}
